import {AlertsActions} from "./alertsActions.enum"
import i18next from "i18next"

const t = i18next.getFixedT(null, "admin");

export const setErrorAlert = (message: string) => {
    return {
        type: AlertsActions.SET_ERROR_ALERT,
        payload: message
    }
}

export const setSuccessAlert = (message: string) => {
    return {
        type: AlertsActions.SET_SUCCES_ALERT,
        payload: message
    }
}

export const setListMessage = (message: string) => {
    return {
        type: AlertsActions.SET_LIST_MESSAGE,
        payload: message
    }
}

export const setDialogError = (message: string) => {
    return{
        type: AlertsActions.SET_DIALOG_ERROR,
        payload: { message, title: t("nav.missingData") as string }
    }
}

export const setDialogApiError = (message: string) => {
    return{
        type: AlertsActions.SET_DIALOG_ERROR,
        payload: { message, title: t("nav.error") as string }
    }
}

export const clearAlerts = () => {
    return{
        type: AlertsActions.CLEAR_ALERTS
    }
}

export const clearListMessages = () => {
    return{
        type: AlertsActions.CLEAR_LIST_MESSAGES
    }
}

export const setListErr = (message: string) => {
    return {
        type: AlertsActions.SET_LIST_ERR,
        payload: message
    }
}